import { ArrowLeft } from 'lucide-react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getParentPanelPath } from '../config/paths';

export interface PageBackButtonProps {
  /** Overrides auto-derived parent path from the current location. */
  to?: string;
  className?: string;
}

/** In-page back control that always navigates to the parent panel route (not browser history). */
const PageBackButton: React.FC<PageBackButtonProps> = ({ to, className = '' }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const href = to ?? getParentPanelPath(pathname);
  if (!href) return null;

  return (
    <Link
      to={href}
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors ${className}`.trim()}
    >
      <ArrowLeft className="h-4 w-4 shrink-0" />
      {t('common.back')}
    </Link>
  );
};

export default PageBackButton;
